<template>
  <ReservationDetailSkeleton v-if="isLoadingSelectedReservation" />
  <ReservationInformation
    v-else
    @close="goToPerformanceReservations"
    @reservationUpdated="reservationUpdated"
    @editReservation="goToReservationEdit"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onMounted, toRefs, watch } from 'vue'
import { useRouter } from 'vue-router'

import { PERFORMANCE_ROUTE_NAMES } from '@/modules/performance/constants/PerformanceRouteConstants'
import { usePerformanceReservationStore } from '@/modules/performance/stores/PerformanceReservationStore'
import ReservationDetailSkeleton from '@/modules/reservation/components/organisms/ReservationDetailSkeleton.vue'
import ReservationInformation from '@/modules/reservation/pages/ReservationInformation.vue'

const props = defineProps<{ reservationId: number; performanceId: number }>()
const { reservationId, performanceId } = toRefs(props)

const router = useRouter()
const performanceReservationStore = usePerformanceReservationStore()
const { isLoadingSelectedReservation, selectedReservation } = storeToRefs(
  performanceReservationStore,
)
onMounted(fetchSelectedReservation)
watch(reservationId, fetchSelectedReservation)
async function fetchSelectedReservation() {
  await performanceReservationStore.loadSelectedReservation(reservationId.value)
  if (selectedReservation.value?.performance_id !== performanceId.value) {
    await router.push({ name: PERFORMANCE_ROUTE_NAMES.RESERVATION_LIST })
  }
}
async function goToPerformanceReservations() {
  performanceReservationStore.setSelectedTableIds([])
  performanceReservationStore.removeSelectedReservation()
  await router.push({ name: PERFORMANCE_ROUTE_NAMES.RESERVATION_LIST })
}
async function reservationUpdated() {
  await Promise.all([
    performanceReservationStore.backgroundRefresh(),
    performanceReservationStore.loadSelectedReservation(reservationId.value),
  ])
}
async function goToReservationEdit() {
  performanceReservationStore.setSelectedTableIds(selectedReservation.value?.tables || [])
  await router.push({ name: PERFORMANCE_ROUTE_NAMES.RESERVATION_EDIT })
}
</script>
